/* eslint-disable react/require-default-props */
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { getSurveyDescription } from '../../utils/surveyDescription';

const SurveyInformationEditForm = ({
  handleEditMode,
  currentSurvey,
  metadataDescriptions,
  busy,
  busyLabel,
  handleSave,
}) => {
  const [title, setTitle] = useState(currentSurvey.title || '');
  const [dateAdministrated, setDateAdministrated] = useState('');
  const [description, setDescription] = useState('');

  const surveySummaryDetailsDto = useMemo(() => {
    const metaDescription = getSurveyDescription(currentSurvey, metadataDescriptions);

    if (metaDescription) {
      return metaDescription;
    }
    return {
      Data: {
        description: 'Click to add Information',
        administered: 'Click to add Information',
      },
    };
  }, [currentSurvey, metadataDescriptions]);

  useEffect(() => {
    if (surveySummaryDetailsDto) {
      setDateAdministrated(surveySummaryDetailsDto?.Data.administered);
      setDescription(surveySummaryDetailsDto?.Data.description);
    }
  }, [surveySummaryDetailsDto]);

  const onSave = () => {
    handleSave({
      title,
      description,
      dateAdministrated,
    });
  };
  return (
    <Col md="3" className="p-3 survey-sidebar edit-mode position-relative">
      {busy && (
        <div className="editor-loading-overlay">
          <Spinner animation="border" role="status" />
          {busyLabel}
        </div>
      )}
      <span
        className="d-flex cursor-pointer"
        onClick={handleEditMode}
        onKeyDown={handleEditMode}
        role="button"
        tabIndex={0}
      >
        <FontAwesomeIcon size="sm" className="mr-3" icon={faChevronLeft} />
        Back to overview
      </span>
      <Col className="info-edit-form">
        <h4>Survey Name</h4>
        <Form.Control
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Survey Name"
          type="text"
          maxLength={70}
          value={title}
        />
        <h4>Description</h4>
        <Form.Control
          as="textarea"
          style={{ height: '100px' }}
          maxLength={500}
          placeholder="Survey Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <span className="hint">Character Limit: 500</span>
        <h4>Time Administered</h4>
        <Form.Control
          value={dateAdministrated}
          onChange={(e) => setDateAdministrated(e.target.value)}
          placeholder="Time Administered"
          type="text"
          maxLength={35}
        />
        <span className="hint">Character Limit: 35</span>
      </Col>
      <Button variant="primary" onClick={onSave} disabled={busy} className="btn btn-custom dark">
        Save
      </Button>
    </Col>
  );
};

SurveyInformationEditForm.propTypes = {
  currentSurvey: PropTypes.shape({
    title: PropTypes.string,
    type: PropTypes.string,
    subType: PropTypes.string,
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    month: PropTypes.string,
  }).isRequired,
  metadataDescriptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  busy: PropTypes.bool,
  busyLabel: PropTypes.string,
  handleEditMode: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default SurveyInformationEditForm;
